import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PageContainer from "../../components/PageContainer/PageContainer";
import useStyles from "assets/jss/material-react/views/italmundoStyles";
import { URLs } from "../../utils/redirectStep";
import { getSessionDocument } from "services/sessionStorageService";
import { Box } from "@mui/material";

function VerificacionCelular() {
  const navigate = useNavigate();
  const location = useLocation();

  const classes = useStyles();

  const modal = {
    open: true,
    showX: false,
    content: (
      <Box className={classes.modalContentDynamic}>
        <p className={classes.modalMessage}>
          No pudimos verificar tu número de teléfono. Por favor{" "}
          <span
            style={{ color: "#04808F", fontWeight: 500, cursor: "pointer" }}
            onClick={() =>
              (window.location.href =
                "https://api.whatsapp.com/send?phone=59897051530&text=%C2%A1Quiero%20continuar%20con%20mi%20solicitud")
            }
          >
            ingresa aquí
          </span>{" "}
          para que podamos ayudarte.
          <br />
          <br />
          ¡Muchas gracias!
        </p>
      </Box>
    ),
  };

  useEffect(() => {
    const documento = getSessionDocument();
    if (!documento) {
      navigate(URLs.home);
    }
  }, []);

  const handleModalCloseClick = () => {
    window.location.href = "https://italmundo.com.uy/";
  };

  return (
    <PageContainer
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.verificacionCelular}
      noImage={true}
    />
  );
}

export default VerificacionCelular;
